import { Cancel } from '@mui/icons-material';
import { Button, Grid, Link, Typography } from '@mui/material';
import { GridRowSelectionModel } from '@mui/x-data-grid';
import { Order } from '@thro-types/leihbar';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useOrderMutation } from 'api/hooks/leihbar';
import { ConfirmationDialog } from 'app/components';
import { translations } from 'locales/i18n';
import { formatToDateAndTime } from 'utils/dates';
import { useAuthContext } from 'utils/hooks/useAuthContext';

import { isLeihBarAdmin } from '../helper';

interface Props {
  order: Order;
  setSelectionModel?: (selected: GridRowSelectionModel) => void;
}

export const OrderDetailHeader = ({ order, setSelectionModel }: Props) => {
  const { t } = useTranslation();

  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);

  const { cancel } = useOrderMutation();
  const { permissions } = useAuthContext();

  const handleCancelOrder = async () => {
    try {
      await cancel.mutateAsync(order.id);
      setSelectionModel && setSelectionModel([]);
    } catch (error) {}
    setCancelDialogOpen(false);
  };

  return (
    <>
      <ConfirmationDialog
        title={t(translations.pages.leihbar.orders.dialogs.cancelOrder.title())}
        open={cancelDialogOpen}
        onClose={() => setCancelDialogOpen(false)}
        onConfirm={handleCancelOrder}
        isPending={cancel.isPending}
      >
        {t(translations.pages.leihbar.orders.dialogs.cancelOrder.message())}
      </ConfirmationDialog>
      <Grid container justifyContent="space-between">
        <Typography variant="h6">
          {t(translations.pages.leihbar.orders.orderNumber())}: {order.id}
        </Typography>
        <Typography variant="h6">
          {t(translations.pages.leihbar.orders.orderDate())}: {formatToDateAndTime(order.createdAt)}
        </Typography>
      </Grid>
      <Grid container justifyContent={'space-between'} alignItems={'center'}>
        <Grid item>
          <Typography>
            {t(translations.pages.leihbar.lender())}: {order.name}
          </Typography>
          <Typography>
            {t(translations.common.email_short())}:{' '}
            <Link href={`mailto:${order.email}`}>{order.email}</Link>
          </Typography>
        </Grid>
        {isLeihBarAdmin(permissions) && setSelectionModel && (
          <Button
            variant="contained"
            onClick={() => setCancelDialogOpen(true)}
            color="error"
            startIcon={<Cancel />}
            disabled={order.bookings?.every(booking => booking.deletedAt !== null)}
          >
            {t(translations.pages.leihbar.orders.cancelOrder())}
          </Button>
        )}
      </Grid>
    </>
  );
};
